import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const ServiceCard = ({ service }) => {
  const { language } = useLanguage();
  const isAr = language === 'ar';

  return (
    <div className="h-full bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col group">
      {/* Color bar */}
      <div className={`h-1.5 ${service.barColor || 'bg-primary-500'}`} />

      <div className="p-7 flex flex-col flex-grow">
        {/* Icon */}
        <div className={`w-14 h-14 ${service.iconBg} ${service.iconColor} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}>
          {service.icon}
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
          {isAr ? service.titleAr : service.titleEn}
        </h2>

        {/* Description */}
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed mb-5 flex-grow">
          {isAr ? service.descAr : service.descEn}
        </p>

        {/* Features */}
        {service.features && (
          <ul className="space-y-2 mb-6">
            {(isAr ? service.features.ar : service.features.en).map((f, i) => (
              <li key={i} className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
                <svg className="w-4 h-4 text-primary-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
                {f}
              </li>
            ))}
          </ul>
        )}

        {/* CTA */}
        <Link
          to="/get-quote"
          className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition group/link"
        >
          {isAr ? 'تواصل معنا' : 'Get in touch'}
          <svg className="w-4 h-4 rtl:rotate-180 group-hover/link:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
